var PubSub = require("underpub-js");

var MobileNavOverlay = function(options){

  this.options = {
    $el: false
  };

  $.extend(true, this.options, options);

};

MobileNavOverlay.prototype.init = function(){

  var self = this;
  
  PubSub.subscribe("showMobileNavOverlay", function(){
    self.show();
  });

  PubSub.subscribe("hideMobileNavOverlay", function(){
    self.hide();
  });

  // mobile nav trigger
  this.options.$el.find('.mobile-nav-trigger').on('click', function() {

    self.hide();

    PubSub.publish('deactivateHamburgers');

  });

};

MobileNavOverlay.prototype.show = function(){

  var self = this;

  this.options.$el.addClass("is-active");

};

MobileNavOverlay.prototype.hide = function(){

  var self = this;

  this.options.$el.removeClass("is-active");

};

module.exports = MobileNavOverlay;
